import { useNavigation } from '@react-navigation/native'
import React, { useCallback } from 'react'
import { Linking } from 'react-native'
import { Text } from 'react-native-paper'
import { commonColors } from '@linqpal/common-frontend/src/theme/colors'

const linkLabel = {
  color: commonColors.accentText,
  fontSize: 14,
  fontWeight: '400',
  lineHeight: 17,
  // backgroundColor:'red'
}

type Props = {
  children?: React.ReactNode
  url?: string
  screen?: string
  params?: any
  onPress?: () => void
  style?: any
  testID?: string
}

export default function LinkLabel({
  children,
  url,
  screen,
  params,
  onPress,
  style,
  testID = '',
}: Props) {
  const navigation = useNavigation()
  const _onPress = useCallback(() => {
    screen && navigation.navigate(screen, params)
    url && Linking.canOpenURL(url).then(() => Linking.openURL(url))
  }, [screen, navigation, params, url])
  return (
    <Text
      onPress={onPress || _onPress}
      style={[linkLabel, style]}
      testID={testID}
    >
      {children}
    </Text>
  )
}
